import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { auth } from '../../firebase'; // Import the auth instance
import { signInWithEmailAndPassword } from "firebase/auth";
import axios from 'axios';
import { API_URL, SOCKET_URL } from '../../apiConfig';

const NGOAuth = ({ setAuthenticated, setUserType, setUser }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // This function calls our backend to get the NGO's profile
    const syncNgoWithBackend = async (firebaseUser) => {
        try {
            const idToken = await firebaseUser.getIdToken();
            const response = await axios.post(
                `${API_URL}/users/auth`, 
                { 
                    role: 'ngo',
                    // The backend will find the existing NGO profile based on the firebaseUid
                },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );
            return response.data;
        } catch (err) {
            console.error("Error syncing NGO with backend:", err);
            setError("Could not retrieve NGO profile from server.");
            return null;
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // Step 1: Sign in with Firebase using the provided credentials
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            
            // Step 2: Sync with backend to get the full user profile
            const backendUser = await syncNgoWithBackend(userCredential.user);

            if (backendUser) {
                // Ensure the user role is 'ngo' before proceeding
                if (backendUser.role !== 'ngo') {
                    setError("This account is not registered as an NGO.");
                    // Optional: Sign the user out of Firebase if they are not an NGO
                    await auth.signOut();
                    setLoading(false);
                    return;
                }
                setUser(backendUser);
                setUserType('ngo');
                setAuthenticated(true);
            }
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    return (
        <motion.div 
            key="ngo"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
        >
            <h3 className="text-xl font-semibold text-center text-gray-700 mb-6">NGO Portal Login</h3>
            
            {error && (
                <div className="p-3 bg-red-100 text-red-700 rounded-lg mb-4 text-sm">
                    {error}
                </div>
            )}

            <form onSubmit={handleLogin} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full px-4 py-2.5 rounded-lg bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-800 transition"
                        placeholder="Enter your NGO email"
                        required
                    />
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full px-4 py-2.5 rounded-lg bg-gray-50 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-800 transition"
                        placeholder="••••••••"
                        required
                    />
                </div>
                
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-3 bg-black text-white rounded-lg font-semibold hover:bg-gray-800 transition-all disabled:bg-gray-400 flex items-center justify-center"
                >
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </form>
        </motion.div>
    );
};

export default NGOAuth;
